module.exports = __webpack_public_path__ + "static/media/logo.f529af51.png";